import React from "react";
import { Download, Map, ShieldCheck, Headset } from "lucide-react";
const trustItems = [{
  id: 1,
  text: "Direkt nedladdning",
  icon: Download
}, {
  id: 2,
  text: "GPX-kartor ingår",
  icon: Map
}, {
  id: 3,
  text: "Detaljerad logistik",
  icon: ShieldCheck
}, {
  id: 4,
  text: "Boka själv & spara",
  icon: Headset
}];
export default function TryggDigitalLeverans() {
  return <section data-section-id="183382" id="varför-välja-vandra-enkelt" className="w-full bg-background border-y border-border py-8 md:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-4 md:gap-8 items-start md:items-center justify-center">
          {trustItems.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.id} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-4 p-3 rounded-full bg-muted/50 text-primary transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="text-xs sm:text-sm font-medium uppercase tracking-widest text-foreground">
                  {item.text}
                </h3>
              </div>;
        })}
        </div>
      </div>
    </section>;
}